import PriceCampaignHandlerCreate from './PriceCampaignHandlerCreate'

export default PriceCampaignHandlerCreate
